module.exports = __webpack_public_path__ + "img/2014-09_bloomberg.e44fe326.png";